import {
  Dialog,
  DialogActions,
  DialogContent,
  Slide,
  withStyles,
} from '@material-ui/core';
import { Warning } from '@material-ui/icons';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../../assets/jss/material-dashboard-pro-react/modalStyle';
import Button from '../../../../components/CustomButtons/Button';
import {
  ModalButtonsContainer, ModalIconContainer, ModalTitle, ModalTitleContainer,
} from '../style';

const Transition = React.forwardRef((props, ref) => <Slide direction="down" ref={ref} {...props} />);

function ConfirmationModal({
  isOpen, cancel, confirm, classes,
}) {
  return (
    <Dialog
      classes={{
        root : classes.center,
        paper: classes.modal,
      }}
      open={isOpen}
      transition={Transition}
      keepMounted
      onClose={cancel}
      aria-labelledby="modal-slide-title"
      aria-describedby="modal-slide-description"
    >
      <DialogContent
        id="modal-slide-description"
        className={classes.modalBody}
      >
        <ModalIconContainer>
          <Warning fontSize="large" className={classes.warningIcon} />
        </ModalIconContainer>
        <ModalTitleContainer>
          <ModalTitle>Do you want to create a new order?</ModalTitle>
        </ModalTitleContainer>
      </DialogContent>
      <DialogActions
        className={`${classes.modalFooter} ${classes.modalFooterCenter}`}
      >
        <ModalButtonsContainer>
          <Button onClick={cancel} color="danger">Not right now</Button>
          <Button data-testid="btn.create-order" onClick={confirm} color="success">Yes, create order</Button>
        </ModalButtonsContainer>
      </DialogActions>
    </Dialog>
  );
}

ConfirmationModal.propTypes = {
  isOpen : PropTypes.bool.isRequired,
  cancel : PropTypes.func.isRequired,
  confirm: PropTypes.func,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
};

ConfirmationModal.defaultProps = {
  confirm: undefined,
};


export default withStyles(styles)(ConfirmationModal);
